import { MisterIcon } from "@rtel/mister-icons";
import { useState } from "react";
import { DragDropContext, Draggable, DropResult, Droppable } from "react-beautiful-dnd";
import { Column } from "react-table";
import { Dropdown, DropdownMenu, DropdownToggle, Input } from "reactstrap";
import styles from "./ColumnVisibilityAndOrderMenu.module.css"
  
  const getItemStyle = (isDragging: boolean, draggableStyle: any) => {
    return{
        ...draggableStyle,
        background: isDragging ? "#4a2975" : "white",
        color: isDragging ? "white" : "black",
        border: `none !important`,
        fontSize: `16px`,
        borderRadius: `5px`,
        top: `${draggableStyle.top - 298}px`,
        left: 'initial !important',        
    }
  };

const ColumnVisibilityAndOrderMenu = (props: ColumnVisibilityAndOrderMenuProps) => {
    const [columnList, setColumnList] = useState(props.columns);

    const onDragEnd = (result: DropResult) => {
        const { source, destination } = result;
        if (!destination) return;

        const items = Array.from(columnList);
        const [newOrder] = items.splice(source.index, 1);
        items.splice(destination.index, 0, newOrder);

        setColumnList(items);
        props.setColumnOrderAndVisibilityHandler(items);
    };

    const toggleVisibilityHandler = (id: string) => {
        let tmpColumns = [...columnList]
        
        tmpColumns.map((value:any) => {
            if(value.id === id){
            value.isVisible = !value.isVisible          
            }
            return value;        
        })
        setColumnList(tmpColumns);
        props.setColumnOrderAndVisibilityHandler(tmpColumns)
    }

    return (
        <Dropdown
            isOpen={props.isVisible}
            toggle={props.toggleVisibility}
            className="d-inline-block position-relative"
        >
            <DropdownToggle
                className="btn header-item "
                id="page-header-user-dropdown"
                tag="button"
            >
                <MisterIcon name="Layout" size="sm" />
            </DropdownToggle>
            <DropdownMenu 
                className={`dropdown-menu-end dropdown-menu-custom profile-menu-dropdown ${styles.dropDownMenu}`}
            >
                <div className={styles.dropDownMenuInner}>
                    <DragDropContext onDragEnd={onDragEnd}>
                        <Droppable droppableId="columnList">
                            {(provided) => (
                                <div
                                    className="columnList"
                                    {...provided.droppableProps}
                                    ref={provided.innerRef}
                                    style={{position: 'relative'}}
                                >
                                    {columnList.map((column: any , index: number) => {
                                        if(column.isDraggable) {             
                                            return (
                                                <Draggable key={column.id} draggableId={String(column.id)} index={index}>
                                                    {(provided, snapshot) => (                                            
                                                        <div
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                            style={getItemStyle(
                                                                snapshot.isDragging,
                                                                provided.draggableProps.style
                                                            )}
                                                            className={styles.dragableItem}
                                                        >
                                                            <div className={styles.flexContainer}>
                                                                <Input 
                                                                    type="checkbox" 
                                                                    checked={column.isVisible} 
                                                                    onChange={() => toggleVisibilityHandler(column.id)}  
                                                                    value={column.id} 
                                                                    className={styles.flexItem}
                                                                    disabled={props.disableColumnsChangeVisibilityForUser.includes(column.id)}
                                                                />
                                                                <span className={`ps-1 ${styles.flexItem}`}>{column.Header}</span>
                                                                <div className={`${styles.iconContainer} ${styles.flexItem}`}>
                                                                    <MisterIcon name="Drag" size="sm" />
                                                                </div>
                                                            </div>
                                                        </div>                                        
                                                    )}
                                                </Draggable>
                                            );
                                        }
                                    })}
                                    {provided.placeholder}
                                </div>
                            )}
                        </Droppable>
                    </DragDropContext>
                </div>
            </DropdownMenu>
        </Dropdown>
    )
}

export default ColumnVisibilityAndOrderMenu;

interface ColumnVisibilityAndOrderMenuProps {
    isVisible: boolean;
    toggleVisibility: () => void;
    setColumnOrderAndVisibilityHandler(column: Array<Column<object>>): void;
    columns: Array<Column<object>>;
    disableColumnsChangeVisibilityForUser: string [];
}